import React from 'react';
import { motion as Motion } from 'framer-motion';
import { siteData } from '../data';

const Culture = () => {
  return (
    <div className="">
      <div className="grid grid-cols-1 lg:grid-cols-2 items-stretch bg-zinc-900 overflow-hidden">
        <Motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="h-[400px] lg:h-auto w-full min-h-[500px] lg:min-h-[850px]"
        >
          <img 
            src={siteData.culture.image} 
            alt="Friske råvarer" 
            className="w-full h-full object-cover"
          />
        </Motion.div>

        <Motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="pt-32 pb-16 lg:pt-40 lg:pb-32 px-4 sm:px-6 lg:pl-20 lg:pr-[calc((100vw-1280px)/2+2rem)] flex flex-col justify-center space-y-8"
        >
          <div>
            <Motion.h1 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-4xl md:text-5xl font-bold text-white mb-6 uppercase tracking-tight"
            >
              {siteData.culture.title}
            </Motion.h1>
            <Motion.p 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="text-zinc-400 text-lg leading-relaxed mb-12"
            >
              {siteData.culture.description}
            </Motion.p>
          </div>

          <div className="space-y-6">
            <h2 className="text-2xl font-bold text-white uppercase tracking-wider">Råvarer med omtanke</h2>
            <p className="text-zinc-400 text-lg leading-relaxed">
              {siteData.culture.content}
            </p>
          </div>
        </Motion.div>
      </div>
    </div>
  );
};

export default Culture;
